import React from 'react';
import PropTypes from 'prop-types';
import { LazyImage } from 'common/components/LazyImage';

import CompactStarRating from './CompactStarRating';

function ProductImage({ starRating, detail, src }) {
  return (
    <div className="product-image__container">
      <LazyImage className="product-image__image" src={src} />
      {!!starRating && (
        <CompactStarRating
          className="product-image__star-rating-container"
          rating={starRating}
        />
      )}
      {!!detail && (
        <div className="product-image__detail-container">{detail}</div>
      )}
    </div>
  );
}

ProductImage.propTypes = {
  src: PropTypes.string.isRequired,
  starRating: PropTypes.number,
  detail: PropTypes.node,
};

export default ProductImage;
